export enum SearchType {
  Topic = 0,
  Name = 1,
}
